<app-menu>
  <div class="desktop">
    <app-voltar class="back" />
    <div class="header">
      <app-titulo text="Editar acréscimo"></app-titulo>
    </div>
    <form #cadastroDisciplina="ngForm" class="form">
      <app-input
        type="text"
        width="100%"
        label="Tipo acréscimo"
        name="TxDescricao"
        [requiredInput]="true"
        [(ngModel)]="form.TxDescricao"
      ></app-input>
      <app-input
        type="number"
        width="100%"
        label="Percentual (%)"
        name="VlPercentual"
        [requiredInput]="true"
        [(ngModel)]="form.VlPercentual"
      ></app-input>
    </form>
    <div class="form-button">
      <app-botao
        width="100%"
        text="Salvar acréscimo"
        (click)="editarAcrescimo()"
        [disabled]="validarForm() ? false : true"
      ></app-botao>
    </div>
  </div>
</app-menu>

<app-loader *ngIf="loader" />
